const actions = {

    READ_QUOTAS_REQUEST: 'READ_QUOTAS_REQUEST',
    READ_QUOTAS_SUCCESS: 'READ_QUOTAS_SUCCESS',
    READ_QUOTAS_ERROR: 'READ_QUOTAS_ERROR',

    READ_ADD_ON_PACKS_REQUEST: 'READ_ADD_ON_PACKS_REQUEST',
    READ_ADD_ON_PACKS_SUCCESS: 'READ_ADD_ON_PACKS_SUCCESS',
    READ_ADD_ON_PACKS_ERROR: 'READ_ADD_ON_PACKS_ERROR',

    SET_STORAGE_QUOTA: 'SET_STORAGE_QUOTA',
    SET_USERS_QUOTA: 'SET_USERS_QUOTA',

    readQuotas: () => ({
        type: actions.READ_QUOTAS_REQUEST,
    }),

    // used when uploading/deleting files in file manager, set the new storage quota
    setStorageQuota: newStorageQuota => ({
        type: actions.SET_STORAGE_QUOTA,
        newStorageQuota,
    }),

    // used when switching plans/purchasing add-on user packs
    setUsersQuota: newUsersQuota => ({
        type: actions.SET_USERS_QUOTA,
        newUsersQuota,
    }),

    readAddonPacks: () => ({
        type: actions.READ_ADD_ON_PACKS_REQUEST,
    }),

};

export default actions;
